/**
 * Offline Interaction MVP feature flags and intervals.
 */

export const OFFLINE_INTERACTION_ENABLED =
  import.meta.env.VITE_OFFLINE_INTERACTION !== 'false';

export const HEALTH_CHECK_INTERVAL_MS = Number(
  import.meta.env.VITE_HEALTH_CHECK_INTERVAL_MS || 30_000,
);

export const SYNC_INTERVAL_MS = Number(
  import.meta.env.VITE_OFFLINE_SYNC_INTERVAL_MS || 5 * 60_000,
);

export const HEALTH_URL = import.meta.env.VITE_HEALTH_URL || '/health';

// Abort a health ping that hangs (connected but server not responding) so
// isReachable doesn't stay stale between intervals.
export const HEALTH_TIMEOUT_MS = Number(
  import.meta.env.VITE_HEALTH_TIMEOUT_MS || 8_000,
);

// After this many failed sync attempts an action becomes terminal ('error')
// instead of retrying forever — stops server spam AND stops it pinning the
// pending count > 0 (which would otherwise keep the idle timeout paused).
export const MAX_SYNC_ATTEMPTS = Number(
  import.meta.env.VITE_MAX_SYNC_ATTEMPTS || 5,
);
